module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "ORIM-Book-Title--Front-Matter-",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_vm._v("Dorothy and t"), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("he Wizard in Oz")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Author-Name--Front-Matter- _idGenParaOverride-1"
  }, [_vm._v("L. Frank Baum")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body--Body- ParaOverride-1"
  }, [_c('img', {
    attrs: {
      "alt": "logo2",
      "src": "Book1/image/logo.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49f70c64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/WizardinOz2.vue
// module id = 66
// module chunks = 0